import { FLYBITS } from '../../../constants';
import axios from '../../../utils/axios';
import { ICDConfig } from '../types/config';

export const updateConfig = async (accessToken: string, tenantId: string, partialConfig: any): Promise<ICDConfig> => {
    const response = await axios.put(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations`, {
        ...partialConfig,
        name: 'codat',
    }, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}

export const getConfig = async (accessToken: string, tenantId: string): Promise<ICDConfig> => {
    const response = await axios.get(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations/codat?initialize=true`, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}



// WEBPACK FOOTER //
// ./src/sub-projects/codat/services/config.ts